export class Job {
  constructor(public removed: boolean, public alias: string, public title: string, public teaser: string, public image: string, public body: string, public id: string) {}
}
